module.exports = __webpack_public_path__ + "assets/lvban.f2eced56.svg";